module.exports = "/images/goto.jpg?e2d0698b630ed40b777f4212368b39af";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/screens/Home/assets/goto.jpg
// module id = YUeX
// module chunks = 0